import { useEffect } from 'react';
import { getSubdomain } from 'helpers/global';
import { getImage } from 'helpers/global';
import { Helmet } from 'react-helmet';
import { syncFavicon } from 'helpers/favicon';
import { useSelector } from 'react-redux';
import { Container } from 'reactstrap';

function AuthHeader() {
  const { isWhiteLabelCompany, isLoadingWhiteLabel, whiteLabelTeam } = useSelector(
    (state) => state.whiteLabel
  );
  const whiteLabelFaviconUrl = whiteLabelTeam?.whiteLabelFavicon
    ? getImage(whiteLabelTeam?.whiteLabelFavicon)
    : null;

  useEffect(() => {
    if (!isWhiteLabelCompany || !whiteLabelFaviconUrl) {
      return;
    }

    syncFavicon(whiteLabelFaviconUrl);
  }, [isWhiteLabelCompany, whiteLabelFaviconUrl]);

  return (
    <>
      <Helmet>
        {isWhiteLabelCompany && whiteLabelTeam?.whiteLabelText && (
          <title>{whiteLabelTeam?.whiteLabelText}</title>
        )}
      </Helmet>

      <div className="header bg-gradient-brand py-7 py-lg-8 pt-lg-9">
        <Container>
          <div className="header-body text-center mb-6">
            {getSubdomain() && isLoadingWhiteLabel ? (
              <div className="spinner-container text-white d-flex align-items-center justify-content-center">
                <div className="spinner-border"></div>
              </div>
            ) : (
              <>
                {isWhiteLabelCompany && whiteLabelTeam?.whiteLabelLogo ? (
                  <img
                    alt={whiteLabelTeam?.whiteLabelText}
                    style={{ maxWidth: '300px' }}
                    src={getImage(whiteLabelTeam?.whiteLabelLogo)}
                  />
                ) : (
                  <img
                    alt="Gather Logo"
                    style={{ maxWidth: '300px' }}
                    src={require('assets/img/brand/GatherLogo2White.png').default}
                  />
                )}
              </>
            )}
          </div>
        </Container>
      </div>
    </>
  );
}

export default AuthHeader;
